import type { VehicleFormRow } from './vehicleTaskConfig';

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `v-${crypto.randomUUID()}`;
  }
  return `v-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/**
 * Normalize planner or API payloads into rows executors can edit.
 */
export function extractPlannerVehicleRows(data: Record<string, unknown> | null | undefined): VehicleFormRow[] {
  if (!data) return [];

  const pickArray = (): unknown[] => {
    const candidates = [
      (data as { vehicles?: unknown }).vehicles,
      (data as { vehicleList?: unknown }).vehicleList,
      (data as { items?: unknown }).items,
      (data as { entries?: unknown }).entries,
    ];
    for (const c of candidates) {
      if (Array.isArray(c)) return c;
    }
    return [];
  };

  const rows = pickArray();
  if (rows.length === 0) return [];

  return rows.map((raw, index) => {
    const r = raw as Record<string, unknown>;
    const id =
      typeof r.id === 'string' && r.id.length > 0
        ? r.id
        : typeof r.vehicleId === 'string'
          ? r.vehicleId
          : `planner-${index}`;

    return {
      id,
      year: String(r.year ?? r.modelYear ?? ''),
      make: String(r.make ?? ''),
      model: String(r.model ?? ''),
      vin: String(r.vin ?? r.VIN ?? ''),
      licensePlate: String(r.licensePlate ?? r.plate ?? r.license ?? ''),
      values: {},
    };
  });
}

export function emptyVehicleRow(): VehicleFormRow {
  return {
    id: randomId(),
    make: '',
    model: '',
    year: '',
    vin: '',
    licensePlate: '',
    values: {},
  };
}

export function mergeRowsWithSaved(
  saved: VehicleFormRow[] | undefined,
  plannerSeed: VehicleFormRow[]
): VehicleFormRow[] {
  if (saved && saved.length > 0) return saved.map((r) => ({ ...r, values: { ...r.values } }));
  if (plannerSeed.length > 0) return plannerSeed.map((r) => ({ ...r, values: { ...r.values } }));
  return [emptyVehicleRow()];
}
